module.exports = __webpack_public_path__ + "b1c8444e52ebf45661bed25c68db3d98.svg";